<template>
    <v-tooltip bottom max-width="500" open-delay="1000">
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
                <slot />
            </div>
        </template>
        <div>
            <p>{{ header.text }}</p>
            <p>{{ filtered }}</p>
        </div>
    </v-tooltip>
</template>

<script>
import { resolveByPath } from '@/utils';

export default {
    name: 'TableCellTooltip',
    props: {
        header: {
            type: Object,
            required: true
        },
        item: {
            type: [Object, String]
        },
        filter: String
    },
    computed: {
        filtered() {
            if (!this.item || typeof this.item == 'string') return this.item;
            const key = this.header.value;
            const value = resolveByPath(key, this.item);

            if (this.filter) return this.$options.filters[this.filter](value);
            return value;
        }
    }
};
</script>
